module.exports = __webpack_public_path__ + "static/img/chair.0b1f45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chair.png
// module id = 220
// module chunks = 1